import GamesByProviderList from '@/components/Slots/GamesByProvider/GameList';
import GamesByProviderHeader from '@/components/Slots/GamesByProvider/Header';
import Layout from '@/components/core/Layout';
import { gameProviders } from '@/constants/build/game_providers';
import { Language } from '@/enums/language';
import { GetServerSidePropsResultWithMetadataAndServerState } from '@/interfaces/pages/getServerSidePropsResultWithMetadataAndDehydratedState';
import { generateCasinoMetadata } from '@/lib/metadata';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetServerSidePropsContext } from 'next';

export default function GamesByProviderPage() {
  return (
    <Layout disabledGap>
      <GamesByProviderHeader />
      <GamesByProviderList />
    </Layout>
  );
}

export async function getServerSideProps({
  params,
  locale,
  res,
}: GetServerSidePropsContext): Promise<GetServerSidePropsResultWithMetadataAndServerState> {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=30, stale-while-revalidate=59',
  );
  const queryClient = new QueryClient();
  const provider = gameProviders.find(p => p?.slug === String(params?.slug));
  const providerDescriptionIndex =
    (gameProviders.findIndex(p => p?.slug === String(params?.slug)) % 6) + 1;

  if (!provider) {
    return {
      notFound: true,
    };
  }

  const [metadata] = await Promise.all([
    await generateCasinoMetadata({
      lang: locale as Language,
      title: provider?.name,
      image: provider?.image
        ? `${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/game-providers/${provider?.image}`
        : undefined,
      description: provider?.name?.includes('Original')
        ? undefined
        : `game_provider_description.${providerDescriptionIndex}`,
      path: `/games/providers/${provider?.slug}`,
      gameProvider: provider,
    }),
  ]);

  return {
    props: {
      metadata: JSON.stringify(metadata),
      dehydratedState: dehydrate(queryClient),
    },
  };
}
